import React from "react";
import {withAuth} from "../../withAuth";
import {withRouter} from "react-router-dom";
import Query from "react-apollo/Query";
import {GET_LAST_NEWS} from "../../../queries";

class LatestNews extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            
        };
    }

    render(){
        return (            
            <Query query = {GET_LAST_NEWS} >
                {({ data, loading, error}) => {
                    if (loading) return <div>loading</div>;
                    if (error) {
                        window.open(`${process.env.SITE_ADDRESS}/noauth/`, '_top'); 
                        return <div>error</div>;
                    }
                    const AllPosts = data.getLastNews.map( function(post, i) {
                        let editurl = `${process.env.SITE_ADDRESS}/new/${post._id}`;
                        const regex = /(<([^>]+)>)/ig;
                        //let formatText = post.text.replace(regex, '');
                        let formatText = post.text.substring(0,150) + '...';
                        return (
                            <div className="col-md-6 mt20px">
                                <div className="row post-area">
                                    <div className="col-md-4">
                                        <div className="post-img" style={{backgroundImage: `url("${process.env.SITE_ADDRESS}/${post.picture}")`}}></div>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="post-ttl">{post.title}</div>
                                        {/*<div className="post-time">{time}</div>*/}
                                        <div className="post-text" dangerouslySetInnerHTML={{__html: formatText}}></div>
                                        <div className="post-href">
                                            <a href={editurl}>More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    });

                    return <div className="IndexMainAccReservesAndTotalBalance" style={{'grid-row':'4'}}>
                        <div className="IndexMainAccReserves">
                            <div className="IndexMainElementIn">
                                <div className="StandartElementTitle">NEWS</div>
                                <div className="StandartElementTopBorder"/>
                            </div>
                            <div class="row post-main-area pb20px">
                                {AllPosts}
                            </div>
                        </div>  
                    </div>
                }
                }
            </Query>          
        )}}

export default withAuth(session => session && session.getCurrentUser)(withRouter(LatestNews));